import $ from 'jquery';

export default class CmgTabNavigator{
    constructor(container){
        this.$container = container;

        this.selectors = {
            mobile: '[nav-mobile]',
            mobileTypeAttr: 'nav-mobile',
            desktop: '[nav-desktop]'
        };

        this.init();
    }

    init() {
        this.$mobileNavigator = this.$container.find(this.selectors.mobile);
        this.$desktopNavigator = this.$container.find(this.selectors.desktop);

        this.mobNavType = this.$mobileNavigator.attr(this.selectors.mobileTypeAttr);

        this.$mobileControls = this.$mobileNavigator.find(this.mobNavType);

        this.bind();
    }

    bind() {
        if (this.mobNavType === 'select') {
            this.renderSelect();

            this.$mobileControls.on('change', e => {
                this.renderSelect(e.target.value);
            });
        }
        else if (this.mobNavType === 'button') {
            this.$mobileControls.on('click', e => {
                e.preventDefault();

                let target = e.target.getAttribute('data-target');

                this.$desktopNavigator.find(target).trigger('click');
            });
        }
    }

    renderSelect(target) {
        this.$mobileControls.each((i, el) => {
            let $select = $(el);
            let fontSize = $select.css('font-size');
            let fontFamily = $select.css('font-family');
            let fontWeight = $select.css('font-weight');
            let letterSpacing = $select.css('letter-spacing');
            let textTransform = $select.css('text-transform');

            var $temp = $('<div style="position: absolute; left: -1000px"></div>');
            $temp.appendTo('body');
            $temp.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'letter-spacing': letterSpacing,
                'text-transform': textTransform
            });
            let text = el.options[el.selectedIndex].text;
            $temp.text(text);
            $select.width(Math.round($temp.width()) + 15);
            $temp.remove();

            if (target) {
                if (this.$desktopNavigator.find(target).attr('data-secondary') != null) {
                    const otherTabs = this.$desktopNavigator.find(target).attr('data-secondary').split(',');
                    for (i = 0; i < otherTabs.length; i++) {
                        const nav = $('<ul class="nav d-none" id="tmpNav"></ul>');
                        nav.append('<li class="nav-item"><a data-toggle="tab" data-target="' + otherTabs[i] + '">nav</a></li>"');
                        nav.find('a').tab('show');
                    }
                }
                this.$desktopNavigator.find(target).trigger('click');
            }
        });
    }
}

$(function () {
    var cmgNavs = $('.nav-tabs-cmg');
    if (cmgNavs.length) {
        cmgNavs.each((i, el) => {
            new CmgTabNavigator($(el));
        });
    }
});